import React from 'react';
import styled from 'styled-components';
import { Container } from 'reactstrap';

const DropAreaDiv = styled.div`
  border: 4px dashed #aaa;
  text-align: center;
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

interface DropAreaProps {
  onFileSelected: (file: File) => void;
  file?: File;
  withButton?: boolean;
}

export default class DropArea extends React.Component<DropAreaProps> {
  fileDropArea: any;
  fileInputRef: any;
  onFileSelected: any;
  file: any;
  withButton: boolean;

  constructor(props) {
    super(props);
    this.fileDropArea = React.createRef();
    this.fileInputRef = React.createRef();
    this.onFileSelected = props.onFileSelected;
    this.file = props.fileToUpload;
    this.withButton = props.withButton;
  }

  renderDropAreaContent(state) {
    if (state.file) {
      return `File selected to upload: ${state.file.name}`;
    } else {
      let label = 'Drag and drop a .csv file here';
      if (this.withButton) {
        label += ' or';
      }
      return label;
    }
  }

  handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && this.onFileSelected) {
      this.onFileSelected(file);
    }
  };

  handleSelectFileClick = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  componentDidMount() {
    const dropArea = this.fileDropArea.current;
    dropArea.ondrop = (e) => {
      if (!this.onFileSelected) return;
      this.onFileSelected(e.dataTransfer.files[0]);
    };

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((event) => {
      dropArea.addEventListener(
        event,
        (e) => {
          e.preventDefault();
          e.stopPropagation();
        },
        false,
      );
    });

    ['dragenter', 'dragover'].forEach((event) => {
      dropArea.addEventListener(
        event,
        (e) => {
          dropArea.classList.add('tpicap-filedrop-highlight');
        },
        false,
      );
    });

    ['dragleave', 'drop'].forEach((eventName) => {
      dropArea.addEventListener(
        eventName,
        (e) => {
          dropArea.classList.remove('tpicap-filedrop-highlight');
        },
        false,
      );
    });
  }

  render() {
    return (
      <DropAreaDiv ref={this.fileDropArea} className="m-2 mb-4 mt-4 p-5">
        <Container className="m-5 p-5">
          <h5>{this.renderDropAreaContent(this.props)}</h5>
          {this.withButton && (
            <>
              <input
                type="file"
                ref={this.fileInputRef}
                onChange={this.handleFileInputChange}
                accept=".csv"
                style={{ display: 'none' }}
              />
              <button
                type="button"
                className="btn btn-primary mt-0"
                onClick={this.handleSelectFileClick}
              >
                Select file...
              </button>
            </>
          )}
        </Container>
      </DropAreaDiv>
    );
  }
}
